module.exports = __webpack_public_path__ + "static/media/circle-instagram.0059dac6.svg";